const LINK = {
	HOME: '/main',

	LOGIN: '/',
	REGISTER: '/register',
	FIND_ID: '/find/id',
	FIND_PW: '/find/password',

	REVIEW: '/review',
	REVIEW_APPLY: '/review/apply',
	REVIEW_POST: '/review/post',

	NOTICE: '/notice',
	NOTICE_POST: '/notice/post',

	GUIDE: '/guide',
	GUIDE_POST: '/guide/post',

	TEAM: '/visit-experience',
	VIEW: '/viewtab-instagram',
	DEVELOP: '/website-outsourcing',

	MY: '/mypage',
};

export default LINK;
